import { render, staticRenderFns } from "./Tribunes.vue?vue&type=template&id=2ac463a8&scoped=true&"
import script from "./Tribunes.vue?vue&type=script&lang=js&"
export * from "./Tribunes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac463a8",
  null
  
)

export default component.exports